// custom typefaces
require('typeface-noto-sans-kr')
require('typeface-catamaran')

// polyfill
require('intersection-observer')

const metaConfig = require('./gatsby-meta-config')

exports.onInitialClientRender = () => {
  // Mermaid CDN 로드
  const script = document.createElement('script')
  script.src = 'https://cdn.jsdelivr.net/npm/mermaid@10.6.1/dist/mermaid.min.js'
  script.onload = () => {
    console.log('Mermaid script loaded successfully')

    window.mermaid.initialize({
      startOnLoad: false,
      theme: (require('./src/utils/storage').getTheme(false)
        ? 'dark'
        : (Math.random() < 0.7 ? 'base' : 'forest')),
      /*
      themeVariables: {
        //── 글로벌 팔레트
        primaryColor: `#3F51B5`,
        primaryTextColor: `#FFFFFF`,
        primaryBorderColor: `#1565C0`,

        secondaryColor: `#FFA726`,
        secondaryTextColor: `#212121`,
        secondaryBorderColor: `#EF6C00`,

        tertiaryColor: `#26A69A`,
        tertiaryTextColor: `#FFFFFF`,
        tertiaryBorderColor: `#00796B`,

        lineColor: `#3249bf`,
        textColor: '#3249bf',
        titleColor: `#3249bf`,

        clusterBkg: `#ECEFF1`,
        clusterBorder: `#90A4AE`,
        edgeLabelBackground: `#ECEFF1`,

        //── 폰트 & 크기 ── 
        fontFamily: '"Noto Sans KR", Arial, sans-serif',
        fontSize: '14px',

        // ── 다이어그램별 추가 ── 
        // 시퀀스 
        actorBkg: `#B0BEC5`,
        actorBorder: `#546E7A`,
        // 간트 
        sectionBkgColor: `#F5F5F5`,
        sectionBkgColor2: `#ECEFF1`,
        ganttTitleFill: `#3F51B5`,
        todayLineColor: `#FF7043`,
        // 파이 
        pie1: `#3F51B5`, pie2: `#FFA726`, pie3: `#26A69A`,
        pie4: `#AB47BC`, pie5: `#29B6F6`
      },
      */
      flowchart: {
        useMaxWidth: true,
        htmlLabels: true,
      },
    });

    const processMermaidBlocks = (idx) => {
      console.log(`processMermaidBlocks ${idx} called`)
      const mermaidBlocks = document.querySelectorAll('pre code.language-mermaid')
      console.log('Found mermaid blocks:', mermaidBlocks.length)

      mermaidBlocks.forEach((block, index) => {
        console.log(`Processing block ${index}:`, block.textContent.substring(0, 50) + '...')

        if (!block.dataset.mermaidProcessed) {
          block.dataset.mermaidProcessed = 'true'

          const mermaidCode = block.textContent
          const container = document.createElement('div')
          container.className = 'mermaid'
          container.id = `mermaid-${Date.now()}-${index}`

          const preElement = block.parentElement.parentElement


          console.log(`Rendering mermaid for block ${index}`, preElement)

          window.mermaid.render(container.id, mermaidCode).then(({ svg }) => {
            preElement.innerHTML = svg
            console.log(`Successfully rendered mermaid block ${index},${idx}`)
          }).catch((error) => {
            console.error('Mermaid rendering error:', error)
            container.innerHTML = `<pre><code>${mermaidCode}</code></pre>`
          })
        }
      })
    }

    window.mermaid.processMermaidBlocks = processMermaidBlocks;




    console.log('Mermaid initialized')






    setTimeout(window.mermaid.processMermaidBlocks(1), 100) // 약간의 지연 추가

  }

  script.onerror = (error) => {
    console.error('Failed to load mermaid script:', error)
  }

  document.head.appendChild(script)

  // ... Facebook 코드 ...
}
